module.exports = __webpack_public_path__ + "static/media/nxt-Coverphotod7637498526c1a37b08acc3953ac5e53png";